import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Format a price stored in cents to a human-readable EUR string.
 * Uses italian locale (`€9,90` with comma) and shows decimals only when needed
 * (`€99` for integers, `€9,90` for fractional). Useful for display in UIs that
 * mix monthly/annual/equivalent prices.
 */
export function formatEuros(cents: number): string {
  const euros = cents / 100
  return new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: Number.isInteger(euros) ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(euros)
}
